import axios from 'axios';
import { getLocale, getProperty } from '@/common/oldMobile';
import { clientLog } from 'nike-ui/src/common/logging/logs';
import { XhrLog } from 'nike-ui/src/common/logging/XhrLog';
import { jwtTokenPromise } from 'nike-ui/src/common/axios/jwtTokenPromise';

if (!axios.__nike_setup) {
    throw Error('wrong axios create order');
}
const cashinusClient = axios.create({
    baseURL: getProperty('cashinus.address')
});

cashinusClient.interceptors.response.use(response => response.data);
cashinusClient.interceptors.request.use(config =>
    jwtTokenPromise()
        .then(token => {
            if (window.USER_DATA_SNAPSHOT.cisloZmluvy) {
                config.headers['Authorization'] = `Bearer ${token}`;
                config.headers['Contract-Id'] = window.USER_DATA_SNAPSHOT.cisloZmluvy;
            }
            if (config.method.toLowerCase() === 'get') {
                config.params = config.params || {};
                config.params.lang = getLocale();
            }
            if (config.method.toLowerCase() === 'post') {
                config.data = config.data || {};
                config.data.lang = getLocale();
            }
            return config;
        })
        .catch(error => {
            clientLog(
                XhrLog({
                    message: 'cashinusClient.interceptors.request',
                    data: { error }
                })
            );

            throw error;
        })
);

export default cashinusClient;
